export default {
  SET_TIPOS_CERTIFICADO(state, payload) {
    state.tiposCertificado = payload;
  }
}